import dayjs from "dayjs";

// Languages
import "dayjs/locale/es";
import "dayjs/locale/fr";
import "dayjs/locale/ko";

// Plugins
import advancedFormat from "dayjs/plugin/advancedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat";
import duration from "dayjs/plugin/duration";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import relativeTime from "dayjs/plugin/relativeTime";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(customParseFormat);
dayjs.extend(relativeTime);
dayjs.extend(timezone);
dayjs.extend(duration);
dayjs.extend(isSameOrBefore);
dayjs.extend(advancedFormat);

/**
 * Parse a time string in the format "HH:mm:ss" to a Dayjs Duration object.
 * Needed to fill one of the gaps in the moment -> dayjs migration,
 * since dayjs doesn't have a built-in way to parse time strings into durations.
 *
 * @param timeStr The time string to parse.
 * @returns A Dayjs Duration object representing the parsed time.
 */
export function parseTimeStringToDuration(
  timeStr: string | undefined
): duration.Duration {
  if (!timeStr) return dayjs.duration(0);
  const [hours, minutes, seconds] = timeStr.split(":").map(Number);
  return dayjs.duration({ hours, minutes, seconds });
}
